<template>
    <div>
        <Form :label-colon="true" :label-width="110">
            <FormItem label="姓名">
                <span slot="label" class="validate">姓名:</span>
                <Input v-model.trim="formData.userName" style="width: 320px" :maxlength="50" placeholder="请填写姓名"></Input>
            </FormItem>
            <FormItem label="手机号码">
                <span slot="label" class="validate">手机号码:</span>
                <Input v-model.trim="formData.phone" style="width: 320px" :maxlength="11" placeholder="请填写手机号码" :disabled="editType === 'update'"></Input>
            </FormItem>
            <FormItem label="头像">
                <LiefengUpload accept=".jpg,.png,.gif,.jpeg" :format="['jpg', 'png', 'jpeg', 'gif']" :target="1" :defaultList="avatarList" :showView="true" @success="onAvatarSuccess"></LiefengUpload>
            </FormItem>
            <FormItem label="民族">
                <Input v-model.trim="formData.national" style="width: 320px" :maxlength="20" placeholder="请填写民族"></Input>
            </FormItem>
            <FormItem label="籍贯">
                <Input v-model.trim="formData.nativePlace" style="width: 320px" :maxlength="50" placeholder="请填写籍贯"></Input>
            </FormItem>
            <FormItem label="通讯地址">
                <Input v-model.trim="formData.address" style="width: 320px" :maxlength="100" placeholder="请填写通讯地址"></Input>
            </FormItem>
            <FormItem label="文化程度">
                <Select v-model="formData.eduDegree" style="width: 320px" placeholder="请选择文化程度">
                    <Option value="0">未知</Option>
                    <Option value="1">小学</Option>
                    <Option value="2">初中</Option>
                    <Option value="3">高中</Option>
                    <Option value="4">大学</Option>
                    <Option value="5">硕士</Option>
                    <Option value="6">博士</Option>
                </Select>
            </FormItem>
            <FormItem label="入职日期">
                <DatePicker style="width: 320px" :value="formData.entryDate" type="date" placeholder="选择入职日期" @on-change="formData.entryDate = $event"></DatePicker>
            </FormItem>
            <FormItem label="办公电话">
                <Input v-model.trim="formData.officePhone" style="width: 320px" :maxlength="20" placeholder="请填写办公电话"></Input>
            </FormItem>
            <FormItem label="紧急联络人">
                <Input v-model.trim="formData.emergencyContact" style="width: 320px" :maxlength="30" placeholder="请填写紧急联络人"></Input>
            </FormItem>
            <FormItem label="联络人电话">
                <Input v-model.trim="formData.emergencyPhone" style="width: 320px" :maxlength="11" placeholder="请填写联络人电话"></Input>
            </FormItem>
            <FormItem label="角色">
                <Select v-model="formData.roleIds" multiple style="width: 320px" placeholder="请选择角色">
                    <Option v-for="item in roleList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </FormItem>
            <FormItem label="流程权限">
                <RadioGroup v-model="formData.flowCode">
                    <Radio label="">无</Radio>
                    <Radio label="1001">拟制</Radio>
                    <Radio label="1002">审核</Radio>
                    <Radio label="1003">发布</Radio>
                    <Radio label="1004">查看</Radio>
                </RadioGroup>
            </FormItem>
        </Form>
    </div>
</template>

<script>
import LiefengUpload from "@/components/LiefengUpload"

export default {
    components: { LiefengUpload },
    props: {
        formData: {
            type: Object,
            default: () => ({}),
        },
        editType: {
            type: String,
            default: "add",
        },
        orgCode: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            roleList: [],
            avatarList: [],
        }
    },
    watch: {
        "formData.avatarUrl"(val) {
            this.avatarList = val ? [{ name: "", url: val }] : []
        },
    },
    created() {
        this.getRoleList()
        this.avatarList = this.formData.avatarUrl ? [{ name: "", url: this.formData.avatarUrl }] : []
    },
    methods: {
        getRoleList() {
            this.$get("/old/api/pc/staff/selectOrgHasRole", {
                orgCode: this.orgCode,
            }).then(res => {
                if (res.code == 200 || res.code == "200") {
                    this.roleList = (res.dataList || []).map(item => ({
                        label: item.name,
                        value: item.id,
                    }))
                }
            })
        },
        onAvatarSuccess(args) {
            this.formData.avatarUrl = args[1].url
        },
    },
}
</script>

<style lang="less" scoped>
/deep/.validate {
    &::before {
        content: "*";
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 14px;
        color: #ed4014;
    }
}
</style>
